// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-prototyping-index-tsx": () => import("./../../../src/pages/prototyping/index.tsx" /* webpackChunkName: "component---src-pages-prototyping-index-tsx" */),
  "component---src-pages-prototyping-thanks-index-tsx": () => import("./../../../src/pages/prototyping/thanks/index.tsx" /* webpackChunkName: "component---src-pages-prototyping-thanks-index-tsx" */),
  "component---src-pages-uireview-index-tsx": () => import("./../../../src/pages/uireview/index.tsx" /* webpackChunkName: "component---src-pages-uireview-index-tsx" */),
  "component---src-pages-uireview-thanks-index-tsx": () => import("./../../../src/pages/uireview/thanks/index.tsx" /* webpackChunkName: "component---src-pages-uireview-thanks-index-tsx" */)
}

